<template>
  <div class="tab-l" :class="className">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "leftTab",
  props: {
    title: {
      type: String,
      default: "xxx",
    },
    className: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="less" scoped>
.tab-l {
  display: inline-block;
  vertical-align: top;
  position: relative;
  font-size: 0.40rem;
  line-height: 0.6465rem;
  color: #000;
  // padding-bottom: 0.3rem;
  font-weight: 700;
  margin-left: 2.6rem;
  margin-bottom: 0.6rem;
  margin-top: 0.6rem;
  // text-transform: uppercase;
  &::after {
    position: absolute;
    display: block;
    content: "";
    width: 1.4rem;
    height: 0.05rem;
    bottom: -0.2rem;
    left: 0.05rem;
    border-bottom: 0.08rem solid #b94060;
  }
}
.Rtab {
  margin-left: 0rem;
}
.Rtab_top0 {
  margin-top: 0rem;
  margin-left: 0rem;
}
.isPolicy {
  &::after {
    display: none;
  }
}
.top0 {
  margin-top: 0rem;
  margin-left: 0rem;
}

@media screen and (max-width: 760px) {
  .tab-l {
    margin-left: 0;
    font-size: 18px;
    margin-bottom: 0.8rem;
    text-align: left;
    &::after {
      border-bottom: 0.12rem solid #b94060;
      bottom: -0.3rem;
    }
  }
  .left30 {
    margin-left: 0.3rem;
  }
  .Rtab_top0 {
    margin-top: 0.6rem;
    margin-left: 0rem;
  }
}
</style>
